import React, { memo } from "react";
import IntroTest from "components/Question/Speaking/IntroTest.jsx";

const SelfIntro = memo( function SelfIntro({
	user, totalQuestions, time
}) {

	return <IntroTest />;
});

export default SelfIntro;